import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAddBookMutation, useEditBookMutation } from "../../features/api/apiSlice";
import Error from "../ui/Error";
import Success from "../ui/Success";


function BookForm({ book }) {

    //Variables
    const [addbook, { isSuccess: addSuccess, isError: addError }] = useAddBookMutation();
    const [editBook, { isSuccess: editSuccess, isError: editError }] = useEditBookMutation();
    const navigate = useNavigate();

    //States
    const [name, setName] = useState("");
    const [author, setAuthor] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [price, setPrice] = useState("");
    const [rating, setRating] = useState("");
    const [featured, setFeatured] = useState(false);

    //Hooks
    useEffect(() => {
        if (addSuccess || editSuccess) {
            resetForm();
            navigate("/books");
        }
    }, [addSuccess, editSuccess, navigate])

    useEffect(() => {
        const { name, author, thumbnail, price, rating, featured } = book || {};
        setName(name);
        setAuthor(author);
        setThumbnail(thumbnail);
        setPrice(price);
        setRating(rating);
        setFeatured(featured);
    }, [book])


    //Functions
    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = {
            name,
            author,
            thumbnail,
            price,
            rating,
            featured
        }
        if (book?.id) {
            editBook({ id: book?.id, data: payload })
        } else {
            addbook(payload);
        }

    };

    const resetForm = () => {
        setName("");
        setAuthor("");
        setThumbnail("");
        setPrice("");
        setRating("");
        setFeatured(false);
    };

    return (
        <form className="book-form" onSubmit={handleSubmit}>
            <div className="space-y-2">
                <label htmlFor="lws-bookName">Book Name</label>
                <input required className="text-input" type="text" id="lws-bookName" name="name" value={name || ""} onChange={(e) => setName(e.target.value)} />
            </div>

            <div className="space-y-2">
                <label htmlFor="lws-author">Author</label>
                <input required className="text-input" type="text" id="lws-author" name="author" value={author || ""} onChange={(e) => setAuthor(e.target.value)} />
            </div>

            <div className="space-y-2">
                <label htmlFor="lws-thumbnail">Image Url</label>
                <input required className="text-input" type="text" id="lws-thumbnail" name="thumbnail" value={thumbnail || ""} onChange={(e) => setThumbnail(e.target.value)} />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
                <div className="space-y-2">
                    <label htmlFor="lws-price">Price</label>
                    <input required className="text-input" type="number" id="lws-price" name="price" value={price || ""} onChange={(e) => setPrice(e.target.value)} />
                </div>

                <div className="space-y-2">
                    <label htmlFor="lws-rating">Rating</label>
                    <input required className="text-input" type="number" id="lws-rating" name="rating" min="1" max="5" value={rating || ""} onChange={(e) => setRating(e.target.value)} />
                </div>
            </div>

            <div className="flex items-center">
                <input id="lws-featured" type="checkbox" name="featured" className="w-4 h-4" checked={featured || false} value={featured} onChange={(e) => setFeatured(!featured)} />
                <label htmlFor="lws-featured" className="ml-2 text-sm" > This is a featured book </label>
            </div>

            <button type="submit" className="submit" id="lws-submit">{book?.id ? "Edit Book" : "Add Book"}</button>
            {(addSuccess || editSuccess) && (
                <Success message="Book was added successfully" />
            )}
            {(addError || editError) && (
                <Error message="There was an error adding book!" />
            )}
        </form>
    )
}

export default BookForm